export const getContinuousPurchasePrice = (
  initialPrice,
  decayConstant,
  emissionRate,
  ageLastAvailableAuction,
  purchaseQuantity,
  priceFloor
) => {
  const t1 = initialPrice / decayConstant;
  const t2 = Math.exp((decayConstant * purchaseQuantity) / emissionRate) - 1;
  const t3 = Math.exp(decayConstant * ageLastAvailableAuction);

  const price = (t1 * t2) / t3;
  return price > priceFloor ? price : priceFloor;
};
